module.exports = __webpack_public_path__ + "static/media/3.c67f1457.jpg";